// extracted by mini-css-extract-plugin
export default {"displaydate":"DisplayDate_displaydate__TJ3Sk"};